import React from "react";
import { TextField } from "@mui/material"



export default function CustomTextField({ formData, field, handleChange, multiline, rows, disabled, readOnly, required, label, type, error, helperText, variant }) {
    return (
        <TextField
            fullWidth
            label={label}
            type={type || "text"}
            required={required || false}
            value={formData[field] || ""}
            onChange={(event) => handleChange(field, event.target.value)}
            multiline={multiline || false}
            rows={rows || 1}
            InputProps={{ readOnly: readOnly || false }}
            margin="dense"
            disabled={disabled || false}
            placeholder={label}
            error={error}
            helperText={helperText || error}
            variant= {variant || "standard"}
        />
    )
}